import { render, staticRenderFns } from "./PreviewSection.vue?vue&type=template&id=05b32237"
import script from "./PreviewSection.vue?vue&type=script&lang=ts"
export * from "./PreviewSection.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PreviewSection.vue?vue&type=style&index=0&id=05b32237&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./PreviewSection.vue?vue&type=style&index=1&id=05b32237&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports